import HttpClient from '@/utility/http-client';

export default {
    getPaymentRequest(page: number, rowPerPage: number, filters: any[], quickFilters: any[]) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/payment-request/?page=${page}&rowsPerPage=${rowPerPage}&q=${quickFilter}&filter=${filter}`;
        return HttpClient.instance().get(url);
    },

    getPaymentRequestByID(id: any) {
        const url = `/api/payment-request/${id}`;
        return HttpClient.instance().get(url);
    },

    createPaymentRequest(dataRequest: any) {
        const url = `/api/payment-request/`;
        return HttpClient.instance().put(url, dataRequest);
    },
}